import { AppBar, List, ListItem, Grid, Box, } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "../shared/Button/Button";
import { useLocation, useNavigate } from 'react-router-dom';
import { Homestyle } from "./Style";
import Dropdownnav from "./Dropdownnav";
import Notifications from './Notifications';
import { ButtonGroup } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { userActions } from '../../actions/user.actions'
export default function Navbar() {
 
  const dispatch = useDispatch();

  const productType = useSelector((state) => state.ProductTypeFilter.selectedProductType);
  // console.log("selected product Type", productType);

  const handleProductTypeChange = (type) => {
    dispatch(userActions.setProductTypeFilter(type));
  };
 
  const decode = useCurrentUser() || {};
  const navigate=useNavigate();
  const isBijayClient =
    decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361';

  const shouldHideLoanFilter =
    decode?.role === "institute_user" ||
    decode?.role === "institute_admin" ||
    decode?.role === "channel_user" ||
    (decode?.role === "institute_cra" && decode?.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e") ||
    isBijayClient;

  const location = useLocation();
  const hideProductTypeTopbar = location.pathname === "/RefundsTracker" || location.pathname === "/Settlements";

  const visibleEmail =
    decode.role !== "institute_user" && decode.role !== "institute_admin" && decode.role !== "channel_user"
      ? decode.email
      : "";


//   const [branches,setBranches]=useState(null)
// const [currBranch,setCurrBranch]=useState(sessionStorage.getItem("bname"))

//   const navigate=useNavigate();
//   const location=useLocation();
//   const userId=decode?.userId

//   const urlForAllBranch=`/branch/fetch/all/${userId}`

//   useEffect(() => {

//     if(sessionStorage.getItem("bname")==="null"||sessionStorage.getItem("bname")===null)
//     {
//       sessionStorage.setItem("bname","Cumulative of all Branches");
//       sessionStorage.setItem("bid",null);

//     }
    
//     setTimeout(() => {
      
//       axiosInstance.get(urlForAllBranch)
//       .then((res)=>{
//         setCurrBranch(sessionStorage.getItem("bname"))
//         setBranches(res.data.res)
  
//       })
//     }, 500);

  
   
//   }, [urlForAllBranch])
  

// const handleSetBranch=(e,item)=>{
//     const currentPage=window.location.pathname

//   if(currentPage==="/feeCycles/description"||currentPage==="/studentList/details")
//   {
//     navigate(-1)
//     alert("change branch first to see description")
//   }
//   else{

//     setCurrBranch(e.target.innerText)
//     sessionStorage.setItem("bid",item._id);
//     sessionStorage.setItem("bname",item.branchName);
//     window.location.reload()
//   }

// }
// const handleSetBranchDefault=(e)=>{
//   const currentPage=window.location.pathname

//   if(currentPage==="/feeCycles/description")
//   {
//     navigate(-1)
//     alert("change branch first to see description")

//   }
//   else
//   {
    
//     setCurrBranch(e.target.innerText)
//   sessionStorage.setItem("bid",null);
//   sessionStorage.setItem("bname","Cumulative of All Branches");

//   window.location.reload()
//   }

// }



const goBack=(e)=>{
  sessionStorage.removeItem("selectedUserId")
  navigate(-1)
  e.preventDefault()
}
  return (
    <Homestyle id="NavBar">
      <AppBar position="static" color="primary" className="appbar">
        <Toolbar>   
          <Grid container alignItems="center">
            {/* Hidden below 767px (matches Sidebar's own mobile breakpoint) — mobile has
                its own hamburger trigger for navigation, and there isn't room for both. */}
            <Grid
              item
              xs={6}
              sm={3}
              sx={{ display: "flex", alignItems: "center", "@media (max-width:767px)": { display: "none" } }}
            >
               {/* { location.pathname==="/"||location.pathname==="/feeCycles"||location.pathname==="/studentList"?null: */}
         
  <Button onClick={(e) => goBack(e)} variant="ghost" size="sm" className="back-button">

<List>

  <ListItem>
    <svg
      width="17"
      height="13"
      viewBox="0 0 17 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5333 6.59058H0.907349M0.907349 6.59058L5.79431 11.4775M0.907349 6.59058L5.79431 1.70361"
        stroke="#101828"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </ListItem>
  <ListItem className="backlft" >Back</ListItem>
</List>
</Button>
</Grid>
           
            {!shouldHideLoanFilter && !hideProductTypeTopbar&& (
            // Stays inline in the same row at every width — Back's Grid item is hidden
            // (not just shrunk) below 767px, so this and the avatar/notification column
            // simply split that freed-up space between them instead of wrapping to a
            // second row.
            <Grid
              item
              xs={6}
              sm={6}
              style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
            >
              <div style={{
                display: "inline-flex",
                alignItems: "center",
                background: "#f3f4f6",
                borderRadius: "10px",
                padding: "3px",
                gap: "2px",
                width: "fit-content",
                flexShrink: 0,
              }}>
                {[
                  { label: "All", value: "all" },
                  { label: "Education", value: "1" },
                  { label: "Personal", value: "2" },
                ].map((item) => {
                  const isSelected = productType === item.value;
                  return (
                    <Button
                      key={item.value}
                      variant="ghost"
                      size="sm"
                      onClick={() => handleProductTypeChange(item.value)}
                      style={{
                        fontFamily: "Outfit",
                        fontWeight: isSelected ? 600 : 500,
                        fontSize: "13px",
                        color: isSelected ? "#D32028" : "#6b7280",
                        background: isSelected ? "#ffffff" : "transparent",
                        border: "none",
                        borderRadius: "7px",
                        height: "auto",
                        padding: "4px 14px",
                        minWidth: 0,
                        boxShadow: isSelected ? "0 1px 4px rgba(0,0,0,0.10)" : "none",
                        transition: "all 0.18s ease",
                        whiteSpace: "nowrap",
                        lineHeight: "20px",
                      }}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </div>
            </Grid>
              )}

{/* } */}
          

            <Grid
              item
              xs={shouldHideLoanFilter || hideProductTypeTopbar ? 12 : 6}
              sm={shouldHideLoanFilter || hideProductTypeTopbar ? 9 : 3}
            >
              <Box textAlign="end" >
              <List>
               <ListItem>
                 {/* display:'flex' avoids this block-level Box reserving extra
                     line-height space around its inline-flex Button child (ambient
                     40px line-height from theme.typography.body1 — see src/theme.js) —
                     without it the bell sits flush against the top of its row instead
                     of centered, unlike the avatar div next to it. */}
                 {decode?.role!=="institute_user" && decode?.role!=="institute_admin" && decode.role !== "channel_user"?<Box sx={{marginRight:'12px', display:'flex', alignItems:'center'}}><Notifications/></Box>:null }
                 {/*
                <div style={{width:'8em',marginRight:'10em'}}>
                     <Dropdown  isOpen={dropDownOpen} toggle={()=>setDropDownOpen(!dropDownOpen)}>
                      <DropdownToggle style={{width:'15em',background:'#fff', color : '#000' ,border:'none'}} caret  >
                        {currBranch}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem  onClick={(e)=>handleSetBranchDefault(e,null)}>
                         Cumulative of all Branches
                        </DropdownItem>

                      {
                        branches?branches.map((item)=>{
                        return(
                        <DropdownItem  onClick={(e)=>handleSetBranch(e,item)}>
                          {item.branchName}
                        </DropdownItem>
                        )
                        }
                      ):null
                      }

                      </DropdownMenu>
                    </Dropdown>

                </div>
                */}
                </ListItem>
                <ListItem  sx={{ marginLeft:"10px"}} >
                  {/* clicking the avatar+name/email cluster opens the account menu
                      (logout) — see Dropdownnav.js, which now owns this trigger. */}
                  <Dropdownnav displayName={decode.display_name} email={visibleEmail}>
                    <div style={{
                      width: 36,
                      height: 36,
                      borderRadius: "10px",
                      background: "linear-gradient(135deg, #D32028 0%, #ff6b6b 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontFamily: "Outfit",
                      fontWeight: 700,
                      fontSize: "14px",
                      flexShrink: 0,
                      boxShadow: "0 2px 8px rgba(211,32,40,0.25)",
                      userSelect: "none",
                    }}>
                      {decode.display_name?.charAt(0)?.toUpperCase() ?? "U"}
                    </div>
                    {/* Below 1370px this is hidden — the name/email move into the
                        dropdown menu itself (see Dropdownnav's displayName/email props)
                        since there isn't room to show them inline at that width. */}
                    <Box
                      className="sarath"
                      sx={{
                        marginLeft: "10px",
                        textAlign: "left",
                        minWidth: 0,
                        maxWidth: 200,
                        display: "none",
                        "@media (min-width:1370px)": { display: "flex" },
                        flexDirection: "column",
                        gap: 0,
                      }}
                    >
                      <span style={{ fontFamily: "Outfit", fontWeight: 600, fontSize: "14px", color: "#111827", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: 1.2, display: "block" }}>
                        {decode.display_name}
                      </span>
                      <span style={{ fontFamily: "Outfit", fontWeight: 400, fontSize: "12px", color: "#9ca3af", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", lineHeight: 1.2, display: "block" }}>
                        {visibleEmail}
                      </span>
                    </Box>
                  </Dropdownnav>
                </ListItem>
              </List>
              </Box>
            </Grid>    
          </Grid>
    
     
        
        </Toolbar>
      </AppBar>
    </Homestyle>
  );
}
